export const ru = {
  translation: {
    //content
    "About-exp": "Мой опыт:",
    "About-exp-details": `По специальности я инженер-механик, направление — технология машиностроения. Во фронтенде официально я с 2019 года. До этого некоторое время самостоятельно изучал HTML и CSS. В общем, я самоучка. Никакого образования, связанного с программированием, кроме курса Front-end в Beetroot Academy, не имею. Мой коммерческий опыт на сегодняшний день составляет около 5 лет. Хотя я являюсь front-end-разработчиком, на данный момент пробую себя в back-end. Люблю учиться чему-то новому.`,
    "About-me": "О себе:",
    "About-me-details": `Я простой и открытый человек. Оптимист с чувством юмора (но это не точно). Обожаю людей, легко коммуницирую с другими. Прежде всего ценю в людях честность. Стрессоустойчивый, хотя и не люблю стрессовые ситуации (думаю, как и все мы). Мои основные интересы — компьютерная техника, железо, программирование, игры и немного спорта. Из музыки слушаю всё, кроме шансона. Люблю смотреть фильмы. Любимый жанр — фантастика.`,
    "Projects page": "Страничка projects",
    "Contact page": "Моя контактная информация",
    "Greetings": "Привет! Меня зовут Виталий. Друзья зовут меня Вентель.",
    "Live": "Я живу",
    "Live-country": "в Украине",
    "Live-earth": "на планете Земля",
    "Live-galaxy": "в галактике Млечный путь",
    "Live-universe": "в нашей вселенной",
    "Hero-description":
      'Мой девиз: "Жизнь - это движение. Застыть можно лишь любуясь красотой."',
    "Email": "Моя почта:",
    "Phone": "Мой телефон:",
    "niagara-mobile": "Мобильное приложение для клиентов Niagara Club",
    "lkames": "Сайт визитка небольшой сметной компании Lkames",
    "bp-manager": "Простой менеджер для сбора бонусных очков в GTA 5 RP",
    "description-website":
      "Этот сайт портфолио использует связку React + Firebase",
    "another-projects": "Мои другие проекты:",
    "snake-game": "Простая игра змейка. Пет-проект.",
    //UI titles
    "[btn-name] About": "Обо мне",
    "[btn-name] Projects": "Мои проекты",
    "[btn-name] Contact": "Контакты",
    "[option-name] Language": "Язык: ",
    "theme-status-dark": "Светлая тема",
    "theme-status-light": "Тёмная тема"
  },
};
